/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AutoConfirmDataRow { 
    cruiseName?: string;
    productId?: string;
    shipName?: string;
    departureDate?: string;
    leadTime?: number;
    isAutoPilot?: boolean;
    minPriceChange?: number;
    maxPriceChange?: number;
}

